import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { KorviuButtonComponent } from '../korviu-button/korviu-button.component';

@Component({
  selector: 'app-resource-load-error',
  standalone: true,
  imports: [TranslatePipe, KorviuButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block w-full' },
  template: `
    <div role="alert" class="flex flex-col items-center gap-3 p-4 text-center">
      <p class="m-0">{{ message() | translate }}</p>
      <korviu-button color="tertiary" size="small" (onclick)="retry.emit()">
        {{ 'common.tryAgain' | translate }}
      </korviu-button>
    </div>
  `
})
export class ResourceLoadErrorComponent {
  readonly message = input('common.dataLoadError');
  readonly retry = output<void>();
}
